import type {IEvent} from "../../api/dto/IEvent";

export const isLiveMatch = (item?: IEvent) => {
  const gtmTime = Math.floor((new Date()).getTime() / 1000);
  const isMatchStart = gtmTime >= (item?.start_time || 0);
  const isMatchEnd = item?.end_time && gtmTime >= item?.end_time;
  return isMatchStart && !isMatchEnd;
}
